/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_2_Term_WebsiteInputs */

const en_terms_section_2_term_website = /** @type {(inputs: Terms_Section_2_Term_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`“Website”`)
};

const lv_terms_section_2_term_website = /** @type {(inputs: Terms_Section_2_Term_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`„Tīmekļvietne”`)
};

/**
* | output |
* | --- |
* | "“Website”" |
*
* @param {Terms_Section_2_Term_WebsiteInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_2_term_website = /** @type {((inputs?: Terms_Section_2_Term_WebsiteInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_2_Term_WebsiteInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_2_term_website(inputs)
	return en_terms_section_2_term_website(inputs)
});